const locale = {
    locale: "de_DE",
    yearFormat: "YYYY",
    monthFormat: "MMMM",
    fieldDateFormat: "MMM dd yyyy",
    dayFormat: "DD",
    monthBeforeYear: true,
    shortWeekDays: ["S", "M", "D", "M", "D", "F", "S"],
};
export default locale;
